import { Switch, Route, Redirect } from 'react-router-dom'
import { styled } from '@mui/material/styles'
import MapPage from './page/Map'
import CoreFooter from './component/map/CoreFooter'
import FormMapLayer from './component/map/FormMapLayer'
import FormReportFeedback from './component/map/FormReportFeedback'
import FormReportSurvey from './component/map/FormReportSurvey'
import FormProfile from './component/map/FormProfile'
import InfoContact from './component/map/InfoContact'
import InfoContent from './component/map/InfoContent'
import Login from './component/verify/Login'
import Verify from './component/verify/Verify'
import ForgotISYL from './component/verify/ForgetPassword'
import ChangeISYL from './component/verify/ChangePassword'
import ResetISYL from './component/verify/ResetPassword'
import FormFeedback from './component/map/FormFeedback'
import CookiesNotify from './CookiesNotice'
import Landing from './component/verify/Landing'

const MainMap = () => {
    return (
        <Root>
            <CookiesNotify />
            <MapPage />
            <CoreFooter />
            <Switch>
                <Route exact path="/login">
                    <Login />
                </Route>
                <Route exact path="/login/verify2fa">
                    <Landing />
                </Route>
                <Route exact path="/verify/:id">
                    <Verify />
                </Route>
                <Route exact path="/forget-password">
                    <ForgotISYL />
                </Route>
                <Route exact path="/change-password">
                    <ChangeISYL />
                </Route>
                <Route exact path="/reset-password/:token">
                    <ResetISYL />
                </Route>
                <Route exact path="/profile">
                    <FormProfile />
                </Route>
                <Route exact path="/map-layer">
                    <FormMapLayer />
                </Route>
                <Route exact path="/contact">
                    <InfoContact />
                </Route>
                <Route exact path="/channel">
                    <InfoContent id={2} />
                </Route>
                <Route exact path="/guide">
                    <InfoContent id={3} />
                </Route>
                <Route exact path="/plan">
                    <InfoContent id={4} />
                </Route>
                <Route exact path="/help">
                    <InfoContent id={8} />
                </Route>
                <Route exact path="/feedback/:stationId">
                    <FormFeedback />
                </Route>
                <Route exact path="/report-feedback">
                    <FormReportFeedback />
                </Route>
                <Route exact path="/report-survey">
                    <FormReportSurvey />
                </Route>
                <Route exact path="/" />
                <Redirect to="/not-found" />
            </Switch>
        </Root>
    )
}

const Root = styled('div')(({ theme }) => ({
    width: '100%',
    height: '100%',
}))

export default MainMap
